import { useMemo, useState } from 'react';
import { BottomSheet } from './BottomSheet';
import { useEmojiCatalog } from '../api/emojibase';
import './emoji-picker.css';

const MAX_RENDER = 5000;

export function EmojiPicker({
  open,
  onClose,
  onPick,
}: {
  open: boolean;
  onClose: () => void;
  onPick: (emoji: string) => void;
}) {
  const { entries, isLoading, isError } = useEmojiCatalog();
  const [query, setQuery] = useState('');

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    const filtered = q
      ? entries.filter((e) => e.label.toLowerCase().includes(q) || e.unicode === query.trim())
      : entries;
    return filtered.slice(0, MAX_RENDER);
  }, [entries, query]);

  return (
    <BottomSheet open={open} onClose={onClose} title="Pick an emoji">
      <input
        className="input emoji-search"
        placeholder="Search emoji…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        autoFocus
      />
      {isLoading ? (
        <p className="emoji-status">Loading…</p>
      ) : isError ? (
        <p className="emoji-status">Couldn’t load emoji.</p>
      ) : results.length === 0 ? (
        <p className="emoji-status">No matches.</p>
      ) : (
        <div className="emoji-grid">
          {results.map((e) => (
            <button
              key={e.hexcode}
              className="emoji-cell"
              title={e.label}
              aria-label={e.label}
              onClick={() => {
                onPick(e.unicode);
                onClose();
              }}
            >
              {e.unicode}
            </button>
          ))}
        </div>
      )}
    </BottomSheet>
  );
}
